import UpgradeList from "./components/UpgradeList.vue";
import PRBList from "./components/PrbList.vue";
// import applicationReport from "./components/applicationReport";
import virtualView from "@/router/virtualView";
import PrbInterview from "@/modules/upgrade/components/PrbInterview.vue";

export default {
  path: "upgrade",
  component: virtualView,
  children: [
    {
      path: "",
      name: "Upgrade Review",
      redirect: "application/list",
    },
    {
      path: "list/:stage?",
      name: "Upgrade List",
      component: UpgradeList,
    },
    {
      path: "prb/:stage?",
      name: "PRB List",
      component: PRBList,
    },
    {
      path: "prb-interview/:stage?",
      name: "PRB Interview List",
      component: PrbInterview,
    },
    // {
    //   path: "reports",
    //   name: "Upgrade Reports",
    //   component: applicationReport,
    // },
  ],
};
